import React from 'react';
import { motion } from 'framer-motion';
import '../../../css/alertpages.css';

const MotionDiv = motion.div;

const Banner = () => {
  return (
    <div className="beta-banner-container">
      <MotionDiv 
        className="beta-banner-content"
        animate={{ x: ['100%', '-100%'] }}
        transition={{
          duration: 35,
          repeat: Infinity,
          ease: "linear"
        }}
      >
        <span className="banner-text">
          🚀 <strong>PHASE 1 BETA TESTING</strong> • FREE UNTIL LAUNCH DAY • SPECIAL PRICING FOR EARLY ADOPTERS • 
          REVOLUTIONIZE YOUR HAWKER STALL TODAY • JOIN THE FUTURE OF POS SYSTEMS • 
          🚀 <strong>PHASE 1 BETA TESTING</strong> • FREE UNTIL LAUNCH DAY • SPECIAL PRICING FOR EARLY ADOPTERS • 
          REVOLUTIONIZE YOUR HAWKER STALL TODAY • JOIN THE FUTURE OF POS SYSTEMS • 
        </span>
      </MotionDiv>
    </div>
  );
};

export default Banner;